import styled from "styled-components";
import pxIntoRem from "../../utils/pxIntoRem";

const LegalPageBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #f9f9fb;
`;

const LegalPageContent = styled.main`
  width: 100%;
  max-width: ${pxIntoRem(980)};
  margin: 0 auto;
  padding: ${pxIntoRem(56)} ${pxIntoRem(24)} ${pxIntoRem(72)};
`;

const LegalPageTitle = styled.h1`
  color: #030322;
  font-family: Inter;
  font-size: ${pxIntoRem(38)};
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  margin: 0 0 ${pxIntoRem(12)};

  @media (max-width: 600px) {
    font-size: ${pxIntoRem(28)};
  }
`;

const LegalPageSubtitle = styled.p`
  color: rgba(3, 3, 34, 0.68);
  font-family: Inter;
  font-size: ${pxIntoRem(16)};
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  margin: 0 0 ${pxIntoRem(34)};
`;

const LegalPageSection = styled.section`
  margin-top: ${pxIntoRem(28)};
`;

const LegalPageSectionTitle = styled.h2`
  color: #6854fc;
  font-family: Inter;
  font-size: ${pxIntoRem(22)};
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  margin: 0 0 ${pxIntoRem(12)};
`;

const LegalPageText = styled.p`
  color: rgba(3, 3, 34, 0.82);
  font-family: Inter;
  font-size: ${pxIntoRem(16)};
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
  margin: 0 0 ${pxIntoRem(10)};
  white-space: pre-line;
`;

export { LegalPageBlock, LegalPageContent, LegalPageSection, LegalPageSectionTitle, LegalPageSubtitle, LegalPageText, LegalPageTitle };
